"use client";
import React, { useState, useEffect, useRef } from "react";

const faqs = [
  {
    q: "Was ist der Budget PC Build Service?",
    a: "Du nennst mir dein Gesamtbudget, ich suche die passenden Komponenten aus, vergleiche Preise und koordiniere die Bestellung (z.B. über Digitec oder Galaxus). Du bezahlst die Teile direkt beim Händler. Für die Teile-Auswahl und Bestellkoordination berechne ich eine Service-Gebühr von 100 CHF. Dazu kommt das gewählte Build-Paket (Basic 120 CHF / Setup 180 CHF / Premium 250 CHF) für den eigentlichen Zusammenbau.",
  },
  {
    q: "Muss ich alle Teile selbst kaufen?",
    a: "Nein. Auf Wunsch kann ich passende Komponenten auswählen und bestellen. Dafür berechne ich eine kleine Service-Gebühr (ab 50 CHF). So bekommst du ein perfekt abgestimmtes System ohne selbst alles recherchieren zu müssen.",
  },
  {
    q: "Installierst du auch Windows?",
    a: "Ja, Windows-Installation ist im Setup Build und Premium Build enthalten. Beim Basic Build kann Windows auf Wunsch als Zusatz hinzugefügt werden (+30 CHF).",
  },
  {
    q: "Kannst du meinen alten PC upgraden?",
    a: "Auf jeden Fall. Ich reinige, tausche Komponenten aus, aktualisiere Treiber und optimiere das System – egal ob RAM, SSD, GPU oder komplette Überarbeitung.",
  },
  {
    q: "Wie lange dauert der Zusammenbau?",
    a: "Ein Standard-Build dauert in der Regel 2–4 Stunden. Je nach Komplexität, Kabelmanagement und Optimierungsaufwand kann es auch etwas mehr sein. Ich nehme mir die Zeit, die es braucht.",
  },
  {
    q: "Baust du auch High-End PCs?",
    a: "Ja, gerne. Von Budget-Builds bis zu High-End-Systemen mit Custom-Kühlung und aufwendigem Kabelmanagement – kein Build ist zu komplex.",
  },
  {
    q: "Wo bist du in der Schweiz?",
    a: "Ich biete meinen Service in der Schweiz an. Details zum Standort werden nach Kontaktaufnahme besprochen. Für maximale Sicherheit empfehle ich die persönliche Übergabe.",
  },
  {
    q: "Gibt es Garantie?",
    a: "Dies ist ein privater Service. Ich gebe keine Shop-Garantie auf Hardware, aber alle Komponenten behalten ihre Herstellergarantie. Ich teste jeden Build ausführlich vor der Übergabe und stehe bei Fragen jederzeit zur Verfügung.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("revealed");
        });
      },
      { threshold: 0.1 }
    );
    sectionRef?.current?.querySelectorAll(".reveal-hidden")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section id="faq" ref={sectionRef} className="relative py-28 lg:py-36 px-6 lg:px-12 overflow-hidden">
      <div className="orb w-[400px] h-[400px] bg-violet-500/5 top-0 left-0" />
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16 reveal-hidden">
          <div className="section-label justify-center mb-4">FAQ</div>
          <h2 className="font-display font-extrabold text-[clamp(2rem,4vw,3.2rem)] text-white leading-tight">
            Häufige{" "}
            <span className="gradient-text">Fragen</span>
          </h2>
        </div>

        <div className="space-y-0 reveal-hidden" style={{ transitionDelay: "100ms" }}>
          {faqs?.map((faq, i) => (
            <div
              key={i}
              className={`faq-item ${openIndex === i ? "open" : ""}`}
            >
              <button
                className="faq-question w-full text-left"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                aria-expanded={openIndex === i}
              >
                <span>{faq?.q}</span>
                <div className="faq-icon">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                    <path d="M12 5v14M5 12h14" />
                  </svg>
                </div>
              </button>
              <div className={`faq-answer ${openIndex === i ? "open" : ""}`}>
                <p>{faq?.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}